import React, { useState} from "react";
import { Formik } from "formik";
import { Input } from "@appkit4/react-components/field";
import {Button} from "@appkit4/react-components/button"
import {Modal} from "@appkit4/react-components/modal"
import * as Yup from "yup";
import UserAgreement from '../../../components/Common/userAgreementData';
import OtpInput from "react-otp-input";
import "../../../styles/login.css";
import displayToastMessage from "../Alert/displayToastMessage";
import email from "../../../assets/images/email.svg";
import view from "../../../assets/images/view.svg";
import pwclogo from "../../../assets/images/tata_motors_logo.png";
import iconeye from "../../../assets/images/icon-eye-closed.svg";
import PropTypes from "prop-types";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
import poweredByLogo from "../../../assets/images/poweredByLogo.png"
import { Checkbox } from "@appkit4/react-components/checkbox";

const OTPBox_Styles = {
  //borderRadius: "50px",
  // background: "#000",
  marginBottom: "15px",
  width: "32px",
  height: "35px",
  border:"1px solid",
  borderColor:"black"
};


function ValidatedLoginForm(props) {
  const mode = process.env.REACT_APP_MODE;
  const [validations, setValidations] = useState("");
  const [isPassword, setIsPassword] = useState(true);
  const [visible, setVisible] = useState(false);
  const [disableOtp, setDisableOtp] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userOTP, setUserOTP] = useState("");
  const { sendRequest: loginValidate} = useHttp();
  const { sendRequest: loginValidateOTP } = useHttp();
  const [isTermsModal, setIsTermsModal] = useState(false);
   const [terms, setTerms] = useState(mode === "dev");
   const [submitted, setSubmitted] = useState(false);
  const handleTermsModalConfirm=()=>{
    setVisible(false);
  }
  const onTermsbtnClicked = (row) => {
    setVisible(true);
  };

  const handleChanges = (data) => {
    setTerms(data);
  };

  const handleTermsModalConfirmAgree=()=>{
    setVisible(false);
    setTerms(true);
  }
  
  const responseHandlerOtp = (result) => {
    var csrf_token = 0;
          if (result.CODE) {
            setValidations("");
            setLoading(false);
            sessionStorage.setItem("roleId", result.MSG[0]?._role_id);
            sessionStorage.setItem("userId", result.MSG[0]?.userId);
            sessionStorage.setItem("orgId", result.MSG[0]?._org_id);
            sessionStorage.setItem("loggedIn", true);
            sessionStorage.setItem("jwtToken", result.MSG[0]?.jwtToken);
            sessionStorage.setItem("refreshToken", result.MSG[0].refreshToken);
            if (result.MSG[0]._role_id == 6) {
              props.history.push("/admin");
            } else if (result.MSG[0]._role_id == 5) {
              props.history.push("/vendor");
            } else if (result.MSG[0]._role_id === null) {
              let MSG = "Please check credentials,Login failed"
              displayToastMessage(MSG,"error")
            }
            else {
              props.history.push({
                pathname: "/organizations",
                state: { userroles: result.MSG},
              });
            }

            let name = `csrf_token=`
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(";");
            for (const element of ca) {
              let c = element;
              while (c.startsWith(" ")) {
                c = c.substring(1);
              }
              if (c.startsWith(name)) {
                csrf_token = c.substring(name.length, c.length);
              }
            }
          } else {
            displayToastMessage(result.MSG, "error");
            setLoading(false);
            return;
          }
  }

  const errorHandlerOtp = (err) => {
    displayToastMessage(err.response.data.MSG, "error");
    setLoading(false);
  }
      
  const otpSubmitHandler = async (otp, values) => {
    if (otp) {
      sessionStorage.setItem("idamLogin","false")
      let data = { ...values, otp: Number(otp), userID: selectedUser };
      loginValidateOTP(APIService.loginValidateOTP(data),
                      responseHandlerOtp,
                      errorHandlerOtp)
    }
     else {
      displayToastMessage("OTP is not valid", "error");
    }
  };

  const handleIDAMLogin = () => {
    try {
      sessionStorage.setItem("idamLogin","true")
      window.location =
        process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
        "/login/idamLoginAuthentication";
    } catch (err) {
      displayToastMessage(err.message, "error");
    }
  };

  const responseHandler = (json) => {
    if (json.CODE) {
          setDisableOtp(false);
          setLoading(false);
          setSelectedUser(json.MSG.userId);
    }
    else{
      displayToastMessage(json.MSG, "error");
      setLoading(false);
      return;
    }
  }

  const errorHandler = (err) => {
    displayToastMessage(err.response.data.MSG, "error");
    setLoading(false);
  }
  
  const handleSubmit = async (values) => {
    setSubmitted(true);
    
    if(terms)
    {
      if (values.email.trim().length) {
        setLoading(true);
      values.email = values.email.trim()
      loginValidate(APIService.loginValidate(values),
                    responseHandler,
                    errorHandler)
      } else {
        displayToastMessage("Please enter a username", "error")
      }
    }else{
      displayToastMessage("Please agree to all the Terms and Conditions", "error")

    }
    
  };
  const handleForgotpwd = (e,data) => {
    props.history.push({pathname:"/forgotpwd",query:data});
  };
  const handlePassword = () => {
    const tempPassword = document.getElementById("field-input-password-style")
    let tempType = tempPassword.getAttribute('type')
    if (tempType === 'password'){
      tempType = 'text'
    }
    else {
      tempType = 'password'
    }
    tempPassword.setAttribute('type', tempType)
    setIsPassword((prev) => !prev);
  };

  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      onSubmit={handleSubmit}
      validationSchema={Yup.object().shape({
        email: Yup.string().trim().email().required("User name is required"),
        password: Yup.string()
          .required("Password is required")
            .min(8, "Login credentials are invalid")
            .matches(/(?=.*[0-9])/, "Login credentials are invalid"),
      })}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
        } = props;
        return (
          <div className="loginBackground">
            <div className="container">
              <div className="row">
                <div className="row fixed-top login-bgm-alignment">
                  <div className="ps-4">
                    <img src={pwclogo}  alt="" height="80px"></img>
                  </div>
                  {/* <div className="vertical-line-header"></div>
                  <div className="pt-3">
                    <p className="header-text">TPRM</p>
                  </div> */}
                </div>
                <div className="col-lg-7 lf-div">
                  <h2 className="wt login-welcome">Welcome to the</h2>
                  <h3 className="login-tprm">Third Party Cybersecurity Assessment Programme </h3>
                  <p className="login-paragraph">
                  for Tata Motors Limited - A Web Based Assessment Questionnaire.
                  </p>
                </div>
                <div className="col-lg-1"></div>             
               {process.env.NODE_ENV === "staging"?
              <div className="col-lg-4 rgt-div">
              <div className="my-5">
                <div className="card-body ">
                    <div>
                      <div className="login-text">Log into your account</div>
                      <div className="empty-div"></div>
                      <div className="HRuler"></div>
                      <div className="empty-div"></div>
                        <div className="form-label-group">
                          <div className="row position-relative t-2rem">
                            <div className="col-md-2">
                              </div>
                              
                          </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
                                :<div className="col-lg-4  loginBackgroundColor rgt-div">
                  <div className="loginScreen">
                    <div className="card-body  ">
                      {disableOtp  ? (
                        <div>
                          <div className="login-text uplodateLoginCss ">Log into your account</div>
                          <div className="empty-div"></div>
                          <form onSubmit={handleSubmit}>
                            <div className="form-label-group userEmailField">
                              <Input
                                type="text"
                                id="userfield-style"
                                title="User name"
                                value={values.email}
                                autoComplete="off"
                                onChange={handleChange("email")}
                                onBlur={handleBlur}
                                suffix={
                                  <img
                                    className="userIcon-style"
                                    src={email}
                                    alt="new"
                                    width="17"
                                  />
                                }
                              />
                            </div>

                            {errors.email && touched.email && (
                              <div className="form-label loginErrorMsg">
                                {errors.email}
                              </div>
                            )}

                            <div className="form-label-group passwordField userEmailField">
                              <Input
                                name="password"
                                type="password"
                                inputId="password-style"
                                title="Password"
                                value={values.password}
                                onChange={handleChange("password")}
                                onBlur={handleBlur}
                                suffix={
                                  <img
                                    className="userIcon-style1"
                                    src={isPassword ? view : iconeye}
                                    alt="new"
                                    width="15"
                                    title={
                                      isPassword
                                        ? "Show Password"
                                        : "Hide Password"
                                    }
                                    onClick={handlePassword}
                                  />
                                }
                              />
                            </div>

                            {errors.password && touched.password && (
                              <div className="form-label loginErrorMsg">
                                {errors.password}
                              </div>
                            )}
                            {validations && (
                              <div className="form-label loginErrorMsg">
                                {validations}
                              </div>
                            )}
                            <Checkbox
                    onChange={(sel) => handleChanges(sel)}
                      checked={terms}
                    className="termsAndCondition"
                  >
                    <div className="conditiontext">
                      I agree to the{" "}
                      <span
                        className="linkTerms"
                         onClick={(e) => onTermsbtnClicked(e)}
                         onKeyDown={(e) => e.preventDefault()}
                      >
                        Terms and Conditions
                      </span>
                    </div>
                  </Checkbox>
                  {!terms && submitted && (
                    <span className="required-label">
                      Please agree to all the Terms and Conditions
                    </span>
                  )}
                            <div className="form-label-group userEmailField">
                              <div className="row t-2rem">
                              
                                <div className="col-md-6">
                                  <Button
                                    size="lg"
                                    kind="negative "
                                    // onClick={handleIDAMLogin}
                                    type="submit"
                                    disabled={loading}
                                    variant="primary"
                                    className="position-relative login-btn-styles "
                                  >
                                    {loading && (
                                      <div
                                        className="spinner-border spinner-border-sm color-white"
                                        aria-hidden="true"
                                      ></div>
                                    )}
                                    &nbsp; <span>Login</span>&nbsp;&nbsp;
                                    <span className="Appkit4-icon icon-arrow-right-fill"></span>
                                  </Button>
                                  
                                </div>
                                <div className="col-md-6">
                                  <Button
                                    size="lg"
                                    kind="negative "
                                    onClick={(e)=>handleForgotpwd(e,'Create New Password')}                                    type="button"
                                    variant="primary"
                                    className="position-relative login-btn-styles"
                                  >
                                  
                                    &nbsp; <span>New User</span>&nbsp;&nbsp;
                                  </Button>
                                  
                                </div>
                              </div>
                            </div>
                            <div className="mt-2 forgot-pwd-alignment">
                              <label className="forgot-pwd">
                                Forgot your password?
                              </label>
                              <label
                                className="forgotpwd-styles"
                                onClick={(e)=>handleForgotpwd(e,'Forgot Password')}
                              >
                                Click here
                              </label>
                            </div>
                          </form>
                        </div>
                      ) : (
                        <div>
                          <div className="otp-text">OTP</div>
                          <div className="empty-div"></div>
                        
                          <form onSubmit={handleSubmit}>
                            <div className="row ">
                            <div className="col-md-6 otpBoxAlignment">
                              <OtpInput
                                renderInput={(props) => <input {...props} />}
                                inputStyle={OTPBox_Styles}
                                value={userOTP}
                                numInputs={6}
                                shouldAutoFocus={true}
                                onChange={(otp) => setUserOTP(otp)}
                                renderSeparator={
                                  <span
                                    style={{
                                      marginLeft: "20px",
                                    }}
                                  />
                                }
                              />
                            </div>
                            </div>
                            {validations && (
                              <div className="form-label loginErrorMsg">
                                {validations}
                              </div>
                            )}
                            <div className="form-label-group ">
                              {disableOtp ? (
                                <button
                                  className="button-login"
                                  type="submit"
                                  disabled={loading}
                                >
                                  {loading && (
                                    <div
                                      className="spinner-border spinner-border-sm"
                                      aria-hidden="true"
                                    ></div>
                                  )}
                                  &nbsp;
                                  <span>Login</span>&nbsp;&nbsp;
                                  <span className="icon-arrow-right-fill"></span>
                                </button>
                              ) : (
                                <div className="row ">
                                  <div className="col-md-4 ps-5">
                                  <Button
                                    className="btnCss"
                                    type="button"
                                    disabled={isSubmitting}
                                    onClick={() =>
                                      otpSubmitHandler(userOTP, values)
                                    }
                                  >
                                    {loading && (
                                      <div
                                        className="spinner-border spinner-border-sm"
                                        aria-hidden="true"
                                      ></div>
                                    )}
                                    &nbsp;
                                    <span>Submit</span>&nbsp;&nbsp;
                                    <span className="icon-arrow-right-fill"></span>
                                  </Button>
</div>
<div className="col-md-4"></div>
                                  <div className="col-md-4  padding-leftotp ps-4">
                                    <Button
                                    kind="secondary   bg-white"
                                      className="borderRadius "
                                      onClick={() => setDisableOtp(true)}
                                    >
                                      Cancel
                                    </Button>
                                  </div>
                                  
                                </div>
                                
                              )}
                            </div>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                </div>}
              </div>
            </div>
            <div className="terms-conditions">
            <div className="row">
            <div className="col-md-9 ">
               

              
             </div>
             <div className="col-md-2">
               <img src={poweredByLogo} className="pwcPoweredBy" alt=""></img>
               </div>
              
             </div>
        <Modal
          className="baseline-modal-showcase user-agreement termsModal"
          visible={visible}
          title="Terms & Conditions"
          bodyStyle={{ maxHeight: "400px" }}
           footerStyle={{ paddingTop: "8px", marginTop: "-8px"}}
          modalStyle={{ width: "60.75rem" ,maxHeight:"fit-content" }}
          onCancel={handleTermsModalConfirm}
          maskCloseable={false}
          closable={false}
          footer={
            <div className="modal-footer">
              <Button
                className='agreeButton'
                size='lg'
                onClick={handleTermsModalConfirmAgree}
              >
                Agree
               </Button>
  
              <Button
                type="submit"
                kind='secondary'
                size='lg'
                onClick={() => setVisible(true)}
                className='secondaryButton disagree'
              >
                Disagree
              </Button>
            </div>
          }
        >
            <UserAgreement />
        </Modal>
      </div>
          </div>
        );
      }}
    </Formik>
  );
}
ValidatedLoginForm.propTypes = {
  history: PropTypes.any,
  values: PropTypes.any,
  touched: PropTypes.any,
  errors: PropTypes.any,
  isSubmitting: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
}
export default ValidatedLoginForm;
